var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNodejs = function SvgNodejs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fc5194b7-a667-4f8a-a561-1a5dbce6bc99",
    "data-name": "Layer 1",
    viewBox: "0 0 589.8 361.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bbf50165-5b36-47a0-a19c-5a781a9f02cf",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.3,83.5l-56.2,32.4a6.7,6.7,0,0,0-3.4,5.8v64.9a6.7,6.7,0,0,0,3.4,5.9L214.3,225a6.9,6.9,0,0,0,6.8,0l56.2-32.5a6.6,6.6,0,0,0,3.3-5.9V121.7a6.5,6.5,0,0,0-3.4-5.8L221.1,83.5a6.1,6.1,0,0,0-3.4-1,5.9,5.9,0,0,0-3.4,1",
    style: {
      fill: "#183149"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "baa59f98-3731-4d46-a310-69e76f54a040",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.1,190.8a6.5,6.5,0,0,0,2,1.7l48.2,27.8,8,4.7a6.7,6.7,0,0,0,3.9.8l1.4-.2,59.2-108.5a4.8,4.8,0,0,0-1.6-1.2L240.5,94.6,221,83.4l-1.7-.7Z",
    style: {
      fill: "#183149"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1b07d5d-6084-469e-ba37-04f5f85b6ab3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217,82.6a6.6,6.6,0,0,0-2.7.9l-56,32.3,60.4,110a6.8,6.8,0,0,0,2.4-.8l56.2-32.5a7.1,7.1,0,0,0,3.3-4.6L219,82.7h-2",
    style: {
      fill: "#183149"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M291.5,361.2a11.2,11.2,0,0,1-5.6-1.5l-17.7-10.5c-2.7-1.5-1.4-2-.5-2.3a33.2,33.2,0,0,0,8-3.7,1.5,1.5,0,0,1,1.3.1l13.7,8.1a1.7,1.7,0,0,0,1.7,0l53.2-30.7a1.7,1.7,0,0,0,.8-1.4V257.8a1.8,1.8,0,0,0-.8-1.5l-53.2-30.7a1.7,1.7,0,0,0-1.7,0l-53.2,30.7a1.9,1.9,0,0,0-.9,1.5v61.4a1.9,1.9,0,0,0,.9,1.5l14.6,8.4c7.9,4,12.7-.7,12.7-5.4V263a1.6,1.6,0,0,1,1.6-1.5h6.7a1.5,1.5,0,0,1,1.5,1.5v60.7c0,10.6-5.7,16.6-15.7,16.6-3.1,0-5.5,0-12.3-3.3l-14-8a11.5,11.5,0,0,1-5.6-9.8V257.8a11.2,11.2,0,0,1,5.6-9.7l53.3-30.8a11.7,11.7,0,0,1,11.2,0l53.3,30.8a11.3,11.3,0,0,1,5.6,9.7v61.5a11.5,11.5,0,0,1-5.6,9.7l-53.3,30.7a10.9,10.9,0,0,1-5.6,1.5",
    transform: "translate(0 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,318.9c-23.3,0-28.2-10.7-28.2-19.7a1.5,1.5,0,0,1,1.5-1.5h6.9a1.4,1.4,0,0,1,1.5,1.3c1.1,7,4.2,10.5,18.3,10.5,11.2,0,16-2.5,16-8.5,0-3.4-1.4-5.9-18.8-7.6-14.6-1.5-23.6-4.7-23.6-16.4s9-17.1,24.2-17.1c17.1,0,25.5,5.9,26.6,18.6a1.6,1.6,0,0,1-.4,1.2,1.7,1.7,0,0,1-1.2.5h-6.9a1.6,1.6,0,0,1-1.5-1.2c-1.6-7.4-5.7-9.7-16.6-9.7s-13.7,4.2-13.7,7.4,1.7,5.1,18.2,7.2,24.2,5.3,24.2,16.8-9.7,18.2-26.6,18.2",
    transform: "translate(0 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,120.7a6.8,6.8,0,0,0-3.4-5.9L66.7,82.3a8.5,8.5,0,0,0-3.1-.9H63a8.5,8.5,0,0,0-3.1.9L3.4,114.8A6.8,6.8,0,0,0,0,120.7v87.6a3.4,3.4,0,0,0,1.7,2.9,3.4,3.4,0,0,0,3.4,0L38.8,192a7,7,0,0,0,3.4-5.9V145.2a6.7,6.7,0,0,1,3.4-5.9L59.9,131a6.9,6.9,0,0,1,3.4-.9,6.7,6.7,0,0,1,3.4.9L81,139.3a6.7,6.7,0,0,1,3.4,5.9v40.9a7,7,0,0,0,3.4,5.9l33.6,19.2a3.4,3.4,0,0,0,3.4,0,3.5,3.5,0,0,0,1.7-3Zm266.5,45.6a1.9,1.9,0,0,1-.9,1.5L372.8,179a1.7,1.7,0,0,1-1.7,0l-19.4-11.2a1.8,1.8,0,0,1-.8-1.5V143.9a1.8,1.8,0,0,1,.8-1.5l19.4-11.2a1.7,1.7,0,0,1,1.7,0l19.4,11.2a1.9,1.9,0,0,1,.9,1.5ZM398.3.4a3.5,3.5,0,0,0-5.1,3V90.1a2.2,2.2,0,0,1-1.2,2,2,2,0,0,1-2.3,0L375.5,84a6.9,6.9,0,0,0-6.8,0l-56.5,32.6a6.8,6.8,0,0,0-3.4,5.9v65.2a6.7,6.7,0,0,0,3.4,5.9l56.5,32.7a6.9,6.9,0,0,0,6.8,0L432,193.6a6.7,6.7,0,0,0,3.4-5.9V25.2a6.8,6.8,0,0,0-3.5-6ZM586.4,143.3a6.8,6.8,0,0,0,3.4-5.9V121.6a6.8,6.8,0,0,0-3.4-5.9L530.3,83.1a6.9,6.9,0,0,0-6.8,0L467,115.7a7,7,0,0,0-3.4,5.9v65.2a6.9,6.9,0,0,0,3.4,6l56.1,32a6.9,6.9,0,0,0,6.7,0l34-18.9a3.4,3.4,0,0,0,1.7-2.9,3.3,3.3,0,0,0-1.7-3L507,167.4a3.5,3.5,0,0,1-1.8-3V144a3.5,3.5,0,0,1,1.8-3l17.6-10.2a3.4,3.4,0,0,1,3.4,0L545.7,141a3.4,3.4,0,0,1,1.7,3v16.1a3.4,3.4,0,0,0,1.7,2.9,3.6,3.6,0,0,0,3.5,0Z",
    transform: "translate(0 0)",
    style: {
      fill: "#183149",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.1,140.3a1.1,1.1,0,0,1,1.3,0l10.8,6.2a1.5,1.5,0,0,1,.7,1.2v12.5a1.4,1.4,0,0,1-.7,1.1l-10.8,6.3a1.5,1.5,0,0,1-1.3,0l-10.9-6.3a1.3,1.3,0,0,1-.6-1.1V147.7a1.4,1.4,0,0,1,.6-1.2Z",
    transform: "translate(0 0)",
    style: {
      fill: "#183149",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3,83.5l-56.2,32.4a6.7,6.7,0,0,0-3.4,5.8v64.9a6.7,6.7,0,0,0,3.4,5.9L214.3,225a6.9,6.9,0,0,0,6.8,0l56.2-32.5a6.6,6.6,0,0,0,3.3-5.9V121.7a6.5,6.5,0,0,0-3.4-5.8L221.1,83.5a6.1,6.1,0,0,0-3.4-1,5.9,5.9,0,0,0-3.4,1",
    transform: "translate(0 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#bbf50165-5b36-47a0-a19c-5a781a9f02cf)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.4,110.4,179.1,32.8,98,198.3l158.2,77.6Z",
    transform: "translate(0 0)",
    style: {
      fill: "#183149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,190.8a6.5,6.5,0,0,0,2,1.7l48.2,27.8,8,4.7a6.7,6.7,0,0,0,3.9.8l1.4-.2,59.2-108.5a4.8,4.8,0,0,0-1.6-1.2L240.5,94.6,221,83.4l-1.7-.7Z",
    transform: "translate(0 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#baa59f98-3731-4d46-a310-69e76f54a040)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7,133.3,199.5,284.6,347.3,175.4,235.5,24.1Z",
    transform: "translate(0 0)",
    style: {
      fill: "#183149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217,82.6a6.6,6.6,0,0,0-2.7.9l-56,32.3,60.4,110a6.8,6.8,0,0,0,2.4-.8l56.2-32.5a7.1,7.1,0,0,0,3.3-4.6L219,82.7h-2",
    transform: "translate(0 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b1b07d5d-6084-469e-ba37-04f5f85b6ab3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.3,82.6V225.8H280.5V82.6Z",
    transform: "translate(0 0)",
    style: {
      fill: "#183149"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNodejs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nodejs.5fc42ae9.svg";
export { ForwardRef as ReactComponent };